/**
 * @generated SignedSource<<7a5cafe24c4123006dff071a7b625ca2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableRateCellValue_roomRate$data = {
  readonly roomPriceAdult: number;
  readonly tripPriceAdult: number;
  readonly " $fragmentType": "RoomRatesTableRateCellValue_roomRate";
};
export type RoomRatesTableRateCellValue_roomRate$key = {
  readonly " $data"?: RoomRatesTableRateCellValue_roomRate$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateCellValue_roomRate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableRateCellValue_roomRate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "roomPriceAdult",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tripPriceAdult",
      "storageKey": null
    }
  ],
  "type": "RoomRate",
  "abstractKey": null
};

(node as any).hash = "f70b8428e60c9303503609d4f10125fa";

export default node;
